import request from '@/utils/request'

/**
 * 同自然日重复充值校验（软提醒）
 * @param {{ memberId: string, bizDate: string|Date, scene: 'Billing'|'Consume', excludeId?: string }} data
 */
export function checkSameDayDuplicate(data) {
  return request({
    url: '/api/Extend/LqBusinessUnitDashboard/CheckSameDayDuplicate',
    method: 'post',
    data
  })
}
